<ngx-loading [show]="!data"></ngx-loading>
<div class="card">
    <h5 class="card-header">
        View Agreement
    </h5>
    <div class="card-body">
        <angular-editor class="rounded-top" disabled id="EmailBody" name="EmailBody" #EmailBody="ngModel" [(ngModel)]="data" [config]="editorConfig"></angular-editor>
    </div>
    <div class="card-footer text-right d-flex justify-content-between">
        <div></div>
        <div class="d-flex flex-wrap align-items-center gap-2">
            <button class="btn btn-default btn-primary submit" type="button" (click)="close()">Cancel</button>
        </div>
    </div>
</div>